<template>
  <section class="site-footer__seo-section">
    <h3 class="site-footer__seo-heading">
      <a :href="section.indexHref" class="site-footer__seo-heading-link">{{ section.title }}</a>
    </h3>
    <div class="site-footer__seo-grid">
      <a
        v-for="(link, index) in primaryLinks"
        :key="`${section.id}-primary-${index}`"
        :href="link.href"
        class="site-footer__seo-link"
        :title="link.title"
        rel="noopener"
      >{{ link.label }}</a>
      <template v-if="expanded">
        <a
          v-for="(link, index) in extraLinks"
          :key="`${section.id}-extra-${index}`"
          :href="link.href"
          class="site-footer__seo-link"
          :title="link.title"
          rel="noopener"
        >{{ link.label }}</a>
      </template>
    </div>
    <button
      v-if="extraLinks.length"
      type="button"
      class="site-footer__seo-toggle hp-btn hp-btn--ghost"
      @click="expanded = !expanded"
    >
      {{ expanded ? 'View less' : `View more ${section.title.toLowerCase()}` }}
      <span class="site-footer__seo-chevron" :class="{ 'site-footer__seo-chevron--open': expanded }">›</span>
    </button>
  </section>
</template>

<script>
export default {
  name: 'FooterSeoSection',
  props: {
    section: { type: Object, required: true },
  },
  data() {
    return { expanded: false };
  },
  computed: {
    primaryLinks() {
      return this.section.links.slice(0, this.section.primaryCount);
    },
    extraLinks() {
      return this.section.links.slice(this.section.primaryCount);
    },
  },
};
</script>
